import { IS_DEVELOPMENT } from '../config/constants';

export default function log(...msgs: any) {
    if (IS_DEVELOPMENT) {
        console.log(...msgs);
    }
}
